module.exports = __webpack_public_path__ + "img/plan.74c2dae6.svg";